import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const EmailAuthLazy = loadable(() => import(/* webpackChunkName: "EmailAuth" */ './EmailAuthSuspense'));

export const EmailAuthAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <EmailAuthLazy />
    </DelayedSuspense>
);
